module.exports = __webpack_public_path__ + "static/img/logo.6a89c0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.png
// module id = iQH9
// module chunks = 64